<template>
  <div class="col-lg-7" v-if="store">
    <div class="delivery-order">
      <div class="media media-delivery">
        <img v-if="brand" :src="brand.goorder_logo" alt="" />
        <div class="media-body">
          <!-- TODO make Fast Food dynamic -->
          <!-- <h6>{{ _T('FAST FOOD') }}</h6> -->
          <h3 class="font-primary">{{ _T_DB(store, 'name') }}</h3>
        </div>
        <span class="badge badge-delivered">{{ _T(orderType) }}</span>
      </div>
      <order-directions :store="store" />
    </div>
  </div>
</template>

<script>
import OrderDirections from '../OrderDirections'
import { mapGetters } from 'vuex'
export default {
  name: 'HeaderLeftPart',
  props: {
    storeId: {
      type: String,
      default: '',
    },
    brandId: {
      type: String,
      default: '',
    },
    orderType: {
      type: String,
      default: 'Delivery Order',
    },
  },
  components: {
    OrderDirections,
  },

  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'find_store_by_main_id',
      'find_brand_by_main_id',
    ]),
    store() {
      if (this.storeId) {
        return this.find_store_by_main_id(this.storeId)
      }
      return ''
    },
    brand() {
      if (this.brandId) {
        return this.find_brand_by_main_id(this.brandId)
      }
      return {}
    },
  },
}
</script>

<style lang="scss" scoped>
// delivery details css
.delivery-order {
  .media-delivery {
    align-items: center;
    margin-bottom: $px15;

    img {
      padding: $px4;
      border: $px2 solid $color-primary;
      border-radius: 100%;
      width: $px64;
      height: auto;
      @media (max-width: 575px) {
        min-width: $px75;
      }
    }

    &.without-border {
      img {
        border: none;
        padding: 0;
      }
    }

    .badge {
      padding: $px10 $px30;
      border-radius: $px25;
      font-weight: 600;
      font-size: $px13;
      line-height: $px19;
      letter-spacing: 0.02em;
    }

    .media-body {
      margin-left: $px16;

      h6 {
        font-size: $px12;
        line-height: $px15;
        margin-bottom: 0;
      }

      h3 {
        font-weight: bold;
        margin-bottom: 0;
      }
    }
  }
  .badge-dine {
    background-color: $color-secondary-1;
    color: $secondary-color;
  }

  .badge-delivered {
    background-color: $color-tertiary-1;
    color: $color-tertiary;
  }

  .badge-carry-out {
    background-color: $warning-color-background;
    color: $warning-color;
  }

  .direction-details {
    padding: $px20 0 $px40;
    border-top: $px1 dashed $light-border;

    .location-map {
      margin-bottom: $px20;

      iframe {
        height: $px154;
      }
    }
  }
}
</style>
